import { render, staticRenderFns } from "./UISettings.vue?vue&type=template&id=bb09f03a&scoped=true"
import script from "./UISettings.vue?vue&type=script&lang=js"
export * from "./UISettings.vue?vue&type=script&lang=js"
import style0 from "./UISettings.vue?vue&type=style&index=0&id=bb09f03a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb09f03a",
  null
  
)

export default component.exports